import { render, staticRenderFns } from "./IP_ByQMMortality.vue?vue&type=template&id=3f648004&scoped=true&"
import script from "./IP_ByQMMortality.vue?vue&type=script&lang=js&"
export * from "./IP_ByQMMortality.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f648004",
  null
  
)

export default component.exports